/**
 * This should have static to list field names (aka htmlNames, <input name>, json key name, etc...).
 */
class FieldHtmlNameUtil {
    static getAllMqlFields() {
        return [
            FieldHtmlNameUtil.badFirstName,
            FieldHtmlNameUtil.badLastName,
            FieldHtmlNameUtil.disposalEmail,
            FieldHtmlNameUtil.competitorEmail,
            FieldHtmlNameUtil.desirableEmail,
            FieldHtmlNameUtil.badJobTitle,
            FieldHtmlNameUtil.badCompanyName,
            FieldHtmlNameUtil.badPhoneNumber,
            FieldHtmlNameUtil.antiSpam,
        ];
    }
}
FieldHtmlNameUtil.telemetryHekateId = 'telemetryHekateId';
FieldHtmlNameUtil.email = 'email';
FieldHtmlNameUtil.desirableEmail = 'desdomain';
FieldHtmlNameUtil.competitorEmail = 'competitor';
FieldHtmlNameUtil.disposalEmail = 'disposal';
FieldHtmlNameUtil.firstName = 'firstName';
FieldHtmlNameUtil.badFirstName = 'bfname';
FieldHtmlNameUtil.lastName = 'lastName';
FieldHtmlNameUtil.badLastName = 'blname';
FieldHtmlNameUtil.phoneNumber = 'phoneNumber';
FieldHtmlNameUtil.ageVerification = 'ageVerification';
/** @deprecated phoneNumber (used by Demo Request, perhaps others) */
FieldHtmlNameUtil.pNumber = 'pnumber';
FieldHtmlNameUtil.badPhoneNumber = 'qphone';
FieldHtmlNameUtil.jobTitle = 'jobTitle';
FieldHtmlNameUtil.badJobTitle = 'bjobtitle';
FieldHtmlNameUtil.companyName = 'companyName';
FieldHtmlNameUtil.badCompanyName = 'bcompany';
/** Mock field that should never show up in form definitions */
FieldHtmlNameUtil.antiSpam = 'antiSpam';
FieldHtmlNameUtil.privacyConsentAccepted = 'privacyConsentAccepted';
FieldHtmlNameUtil.chooseOnshapeEvaluatingStatus = 'chooseOnshapeEvaluatingStatus';
FieldHtmlNameUtil.numberOfCadUsers1 = 'numberofCADUsers1';
FieldHtmlNameUtil.primaryCadSystem = 'cadsystem';
FieldHtmlNameUtil.maxCountry = 'maxcountry';
FieldHtmlNameUtil.maxState = 'maxstate';
FieldHtmlNameUtil.maxCity = 'maxcity';
FieldHtmlNameUtil.reasonForDownloading = 'reasonForDownloading';
FieldHtmlNameUtil.industry = 'industry1';
FieldHtmlNameUtil.websiteurl = 'websiteurl';
FieldHtmlNameUtil.submit = 'submit';
FieldHtmlNameUtil.companyRevenue = 'companyRevenue';
/** The name of the field that olds the trial plan ID (e.g. PRO_COMPANY_TRIAL) */
FieldHtmlNameUtil.planId = 'planId';
/** Name of the APP plan id field */
FieldHtmlNameUtil.appPlanId = 'appPlanId';
/** CAM for first robotics access code */
FieldHtmlNameUtil.camKopCode = 'camKopCode';
/** First robotics team number */
FieldHtmlNameUtil.camTeamNumber = 'camTeamNumber';
/** First robotics team type */
FieldHtmlNameUtil.camProgramFrcOrFTC = 'camProgramFrcOrFTC';
/** @deprecated use maxCountry instead */
FieldHtmlNameUtil.country = 'country';
FieldHtmlNameUtil.recaptcha = 'hekateRecaptcha';
FieldHtmlNameUtil.recaptchaId = 'recaptchaId';
FieldHtmlNameUtil.recaptchaVersion = 'recaptchaVersion';
FieldHtmlNameUtil.approveUser = 'approveUser';
FieldHtmlNameUtil.isEvalCenter = 'evalCenter';
FieldHtmlNameUtil.educationType = 'educationType';
FieldHtmlNameUtil.eduRole = 'eduRole1';
FieldHtmlNameUtil.schoolLevel = 'schoolLevel1';
FieldHtmlNameUtil.schoolName = 'schoolName';
FieldHtmlNameUtil.schoolTitlePosition = 'schoolTitlePosition';
FieldHtmlNameUtil.educatorOf = 'educatorOf';
/** aka the "I am a" question on the Eval Center sign up Form */
FieldHtmlNameUtil.chooseCadUserOrManagerStatus = 'chooseCadUserOrManagerStatus';
/** Questions for edu forms */
FieldHtmlNameUtil.isFacultyOrVolunteer = 'isFacultyOrVolunteer';
/** Questions for edu forms */
FieldHtmlNameUtil.isUsingForEducationOnly = 'isUsingForEducationOnly';
/** Questions for edu forms */
FieldHtmlNameUtil.isThirteenYearsOldOrSupervised = 'isThirteenYearsOldOrSupervised';
/** Questions for edu forms */
FieldHtmlNameUtil.isUsingForOwnEducation = 'isUsingForOwnEducation';
/** Questions for edu forms */
FieldHtmlNameUtil.isAgreeToTermsOfService = 'isAgreeToTermsOfService';
FieldHtmlNameUtil.isCadInClassEducator = 'isCadInClassEducator';
FieldHtmlNameUtil.yearOfGraduation = 'yearOfGraduation';
FieldHtmlNameUtil.useOfOnshapeComment = 'useOfOnshapeComment';
FieldHtmlNameUtil.areaOfStudyOrDegree = 'areaOfStudyOrDegree';
FieldHtmlNameUtil.formVariant = 'formVariant';
FieldHtmlNameUtil.hiddenStaticField1 = 'hiddenStaticField1';
FieldHtmlNameUtil.hiddenStaticField2 = 'hiddenStaticField2';
FieldHtmlNameUtil.proTrialChooseOnshapeEvaluatingStatus = 'proTrialChooseOnshapeEvaluatingStatus';
// this has been changed to productUpdates
FieldHtmlNameUtil.isPremiumContentSubscription = 'isPremiumContentSubscription';
FieldHtmlNameUtil.isUpcomingEventsSubscription = 'isUpcomingEventsSubscription';
FieldHtmlNameUtil.isOnshapeNewsletterSubscription = 'isOnshapeNewsletterSubscription';
FieldHtmlNameUtil.isBlogRoundUpSubscription = 'isBlogRoundUpSubscription';
FieldHtmlNameUtil.preferredLanguage = 'preferredLanguage';
FieldHtmlNameUtil.isUnsubscribe = 'isUnsubscribe';
// this has been changed to productUpdates
FieldHtmlNameUtil.isHPremiumContentSubscription = 'isHPremiumContentSubscription';
FieldHtmlNameUtil.isHUpcomingEventsSubscription = 'isHUpcomingEventsSubscription';
FieldHtmlNameUtil.isHOnshapeNewsletterSubscription = 'isHOnshapeNewsletterSubscription';
FieldHtmlNameUtil.isHBlogRoundUpSubscription = 'isHBlogRoundUpSubscription';
FieldHtmlNameUtil.isHUnsubscribe = 'isHUnsubscribe';
FieldHtmlNameUtil.referrerFullName = 'referrerFullName';
FieldHtmlNameUtil.businessUnit = 'businessUnit';
FieldHtmlNameUtil.utmSource = 'utm_source';
FieldHtmlNameUtil.utmMedium = 'utm_medium';
FieldHtmlNameUtil.utmCampaign = 'utm_campaign';
FieldHtmlNameUtil.utmGclid = 'utm_gclid';
FieldHtmlNameUtil.wwwSiteLanguage = 'wwwSiteLanguage';
FieldHtmlNameUtil.referringWwwFormUrl = 'referringWwwFormUrl';
FieldHtmlNameUtil.offsiteReferringUrl = 'offsiteReferringUrl';
FieldHtmlNameUtil.howDidYouHearAboutUsSummary = 'howDidYouHearAboutUsSummary';
FieldHtmlNameUtil.howDidYouHearAboutUsConcat = 'howDidYouHearAboutUsConcat';
FieldHtmlNameUtil.howCanWeHelpYou = 'howCanWeHelpYou';
FieldHtmlNameUtil.haveColleaguesInterestedInTrial = 'haveColleaguesInterestedInTrial';
FieldHtmlNameUtil.pauseEmailsExpiry = 'pauseEmailsExpiry';
FieldHtmlNameUtil.pauseEmailsFor30 = 'pauseEmailsFor30';
FieldHtmlNameUtil.isHPauseEmailsFor30 = 'isHPauseEmailsFor30';
FieldHtmlNameUtil.whatBestDescribesYou = 'whatBestDescribesYou';
FieldHtmlNameUtil.howDidYouHearAboutUs = 'howDidYouHearAboutUs';
FieldHtmlNameUtil.numberOfCadUsers = 'numberOfCadUsers';
FieldHtmlNameUtil.currentCadSystem = 'currentCadSystem';
FieldHtmlNameUtil.levelOfInterestInNewCad = 'levelOfInterestInNewCad';
FieldHtmlNameUtil.timeframeForDecision = 'timeframeForDecision';
FieldHtmlNameUtil.readyToUpgrade = 'readyToUpgrade';
FieldHtmlNameUtil.yearsOfCommitment = 'yearsOfCommitment';
FieldHtmlNameUtil.billingEmail = 'billingEmail';
FieldHtmlNameUtil.billingAddress = 'billingAddress';
FieldHtmlNameUtil.referredEmail = 'referredEmailAddress';
FieldHtmlNameUtil.doYouUseCadAtWork = 'doYouUseCadAtWork';
FieldHtmlNameUtil.interestedInOnshapeAtWork = 'interestedInOnshapeAtWork';
FieldHtmlNameUtil.cadConsiderations = 'cadConsiderations';
FieldHtmlNameUtil.startupHowDidYouHear = 'startupHowDidYouHearAboutUs';
FieldHtmlNameUtil.startupTellUsAboutYourBusiness = 'startupTellUsAboutYourBusiness';
FieldHtmlNameUtil.howHasOnshapeHelped = 'howHasOnshapeHelped';
FieldHtmlNameUtil.startupCanWeShare = 'startupCanWeShare';
FieldHtmlNameUtil.startupArenaPLM = 'startupArenaPLM';
FieldHtmlNameUtil.startupBusinessSummaryUpdate = 'startupBusinessSummaryUpdate';
FieldHtmlNameUtil.investorName = 'investorName';
FieldHtmlNameUtil.personaDetail = 'personaDetail';
/** signup - usage intent */
FieldHtmlNameUtil.whatIsYourIntent = 'whatIsYourIntent';
/** signup - CAD experience */
FieldHtmlNameUtil.whatIsYourExperience = 'whatIsYourExperience';
/** Did you study Engineering in School? */
FieldHtmlNameUtil.studyEngineering = 'studyEngineering';
/** What is your highest level of education completed? */
FieldHtmlNameUtil.highLevelEdu = 'highLevelEdu';
/** What is/was your major in school? */
FieldHtmlNameUtil.majorInSchool = 'majorInSchool';
FieldHtmlNameUtil.studentGraduationYear = 'studentGraduationYear';
FieldHtmlNameUtil.whatDoYouTeach = 'whatDoYouTeach';
FieldHtmlNameUtil.useCadInClass = 'useCadInClass';
FieldHtmlNameUtil.areaOfStudy = 'areaOfStudy';
FieldHtmlNameUtil.acceptedIsEducator = 'acceptedIsEducator';
FieldHtmlNameUtil.acceptedIsClassroom = 'acceptedIsClassroom';
FieldHtmlNameUtil.cadCheckStatusCode = 'cadCheckStatusCode';
FieldHtmlNameUtil.whenIsYourCadRenewal = 'whenIsYourCadRenewal';
FieldHtmlNameUtil.chooseYourOnshapePlan = 'chooseYourOnshapePlan';
FieldHtmlNameUtil.whatIsYourCadExperience = 'whatIsYourCadExperience';
FieldHtmlNameUtil.eduLevel = 'schoolLevel';
FieldHtmlNameUtil.classroomName = 'classroomName';
FieldHtmlNameUtil.eduDepartmentName = 'eduDepartmentName';
FieldHtmlNameUtil.eduPosition = 'eduPosition';
FieldHtmlNameUtil.whatAreYouUsingOnshapeFor = 'whatAreYouUsingOnshapeFor';
FieldHtmlNameUtil.acceptedIs13YearsOldOrOlder = 'acceptedIs13YearsOldOrOlder';
FieldHtmlNameUtil.ussPath = 'ussPath';
FieldHtmlNameUtil.isEduRenew = 'isEduRenew';
FieldHtmlNameUtil.isProUpgrade = 'isProUpgrade';
FieldHtmlNameUtil.cadInviteRequestJson = 'cadInviteRequestJson';
FieldHtmlNameUtil.uxParadigm = 'uxParadigm';
FieldHtmlNameUtil.cadInviteStatusCode = 'cadInviteStatusCode';
FieldHtmlNameUtil.telemetryHekateBuild = 'telemetryHekateBuild';
FieldHtmlNameUtil.howManyCadUsersAtCompany = 'howManyCadUsersAtCompany';
FieldHtmlNameUtil.tosConsentAccepted = 'tosConsentAccepted';
FieldHtmlNameUtil.privacyConsentAcceptedStudent = 'privacyConsentAcceptedStudent';
FieldHtmlNameUtil.skuGranted = 'skuGranted';
FieldHtmlNameUtil.eventSelection = 'eventSelection';
FieldHtmlNameUtil.signupRedirectUrl = 'signupRedirectUrl';
FieldHtmlNameUtil.referralCode = 'referralCode';
FieldHtmlNameUtil.itarReg = 'ITARreg';
/** geo fields from heartbeat  */
FieldHtmlNameUtil.geoCountry = 'geocountry';
FieldHtmlNameUtil.geoState = 'geostate';
FieldHtmlNameUtil.geoCity = 'geocity';
/** Add Five Friends to Pro Trial Fields  */
FieldHtmlNameUtil.howManyUserToTrial = 'howManyUserToTrial';
FieldHtmlNameUtil.addEmail1 = 'addEmail1';
FieldHtmlNameUtil.addEmail2 = 'addEmail2';
FieldHtmlNameUtil.addEmail3 = 'addEmail3';
FieldHtmlNameUtil.addEmail4 = 'addEmail4';
FieldHtmlNameUtil.addEmail5 = 'addEmail5';
/** Fields used for AB tests */
FieldHtmlNameUtil.experimentId = 'experimentId';
FieldHtmlNameUtil.vwoUuid = 'vwoUuid';
FieldHtmlNameUtil.abVersion = 'abVersion';
export default FieldHtmlNameUtil;
